<template>
  <div v-show="isShow" id="drawEndUI">
    <div class="drawEndUI__base">
      <!--<div class="drawEndUI__debug">
        <div class="buttonMini" @click="showFx = !showFx">showFx</div>
      </div>-->
      <transition name="fx" v-on:enter="enterFx">
        <div class="drawEndUI__fx drawEndUIFx" v-show="isDrawnNow">
          <div class="drawEndUIFx__fx"></div>
          <div class="drawEndUIFx__head">
            <span
              v-for="(t, index) in '描きこまれました！'"
              :key="index"
              v-text="t"
              class="spanLetters"
            />
          </div>
          <div class="drawEndUIFx__foot">
            <span
              v-for="(t, index) in '目の前のスクリーンを見てね。'"
              :key="index"
              v-text="t"
              class="spanLetters"
            />
          </div>
        </div>
      </transition>
      <transition name="operation">
        <div class="drawEndUI__operation" v-show="!isDrawnNow">
          <div class="drawEndUI__head">
            <div
              @click="gotoHome"
              class="gotoHomeBtn buttonMini buttonMini--circle38 button--dark"
            >
              <img src="@/assets/ui/btn-home.png" width="22" alt="" />
            </div>
            <div
              @click="confirmRetryDraw"
              class="redrawBtn buttonMini  button--dark bold"
            >
              描き直す
            </div>
          </div>

          <div class="drawEndUI__footBg"></div>
          <div class="drawEndUI__foot">
            <div class="toFrontButtons">
              <div
                @click="toFront"
                class="button button--dark bold"
                :class="{ 'button--disable': !toFrontAPIEnable }"
              >
                最前面に出す
              </div>
              <div class="text textShadow" v-show="toFrontAPIEnable">
                隠れたり見えなくなった絵を全て表示できます。
              </div>
              <div class="text textShadow" v-show="!toFrontAPIEnable">
                一度押すと、約{{ closeTimeSec }}秒間押すことができません。
              </div>
            </div>
          </div>
        </div>
      </transition>
    </div>
    <div
      class="drawEndUI__modal drawEndUI__modal--reset"
      v-show="viewState == 3"
    >
      最前面に表示しました。<br />スクリーンでご確認ください。
    </div>
    <div
      class="drawEndUI__modal drawEndUI__modal--deleted"
      v-show="viewState == 4"
    >
      <div class="drawEndUI__modalText">
        削除しました<span class="endLetter">。</span>
      </div>
      <div class="buttonPrimary" @click="clickDeleteDoneOK">OK</div>
    </div>
    <div v-show="viewState == 2" class="drawEndUI__modal">
      <div class="deleteModal">
        <div class="deleteModal__text bold">
          記録されたあなたの<br />
          メッセージを削除します<span class="endLetter">。</span>
        </div>
        <div class="deleteModal__text2 bold">よろしいですか？</div>
        <div @click="deleteMessage" class="buttonPrimary">OK</div>
        <div @click="cancel" class="textButton">キャンセル</div>
      </div>
    </div>
  </div>
</template>

<script>
import { isModeEnd } from "../../util/StoreUtil";
import API from "../../api/API";
import { DrawEvent } from "../../events/DrawEvent";
import * as StoreUtil from "../../util/StoreUtil";
import * as drawEventType from "../../events/DrawEventType";
import * as Modal from "../../modal/ModalEvent";
import { TweenMax, Expo } from "gsap";
import { spanAnim } from "../../util/TweenUtil";
export default {
  name: "DrawEndUI.vue",
  computed: {
    /**
     * いま書き込んだかどうか
     */
    isDrawnNow() {
      return this.$store.state.canvas.drawn;
    },
    isShow() {
      return isModeEnd();
    },
    closeTime() {
      return this.$store.state.config.modalAutoCloseTime;
    },
    closeTimeSec() {
      return Math.round(this.$store.state.common.toFrontAPIInterval / 1000);
    },
    toFrontAPIEnable() {
      return this.$store.state.common.toFrontAPIEnable;
    }
  },
  data() {
    return {
      showFx: false,
      viewState: 1
    };
  },
  mounted() {},
  methods: {
    enterFx() {
      spanAnim(".drawEndUIFx__head > span");
      TweenMax.fromTo(
        ".drawEndUIFx__foot",
        0.5,
        { opacity: 0, y: 8 },
        { opacity: 1.0, y: 0, ease: Expo.easeOut, delay: 0.9 },
        0.03
      );

      const hideDelay = 10;
      TweenMax.delayedCall(hideDelay, () => {
        this.showFx = false;
      });
      TweenMax.delayedCall(hideDelay + 0.5, () => {
        StoreUtil.setDrawn(false);
      });
    },
    gotoHome() {
      location.reload();
    },
    confirmRetryDraw() {
      this.viewState = 2;
    },
    retryDraw() {
      console.log("retryDraw");
      // イベント発行？
      // API叩く→ localstorageとか消す
    },
    toFront() {
      console.log("tofront");
      StoreUtil.showLoading();
      API.toFrontMessage()
        .then(
          () => {
            StoreUtil.hideLoading();
            this.showSuccessToFront();
            gtag("event", "Display_On_Front", { event_category: "RENGA_POST" });
          },
          e => {
            console.log("toFrontMessage error");
            if (e.message.indexOf("404") > -1) Modal.showDeleteMessage();
            else if (e.message.indexOf("403") == -1)
              Modal.showAPIError("touch_last");
          }
        )
        .finally(() => {
          StoreUtil.hideLoading();
        });
    },
    deleteMessage() {
      console.log("delete message");
      StoreUtil.showLoading();
      API.deleteMessage()
        .then(
          () => {
            DrawEvent.emit(drawEventType.RESET);
            StoreUtil.hideLoading();
            this.showSuccessDelete();
            gtag("event", "Delete_And_Redraw", {
              event_category: "RENGA_POST"
            });
            // DrawEvent.emit(drawEventType.RESET);
            // this.gotoSiteTop();
          },
          e => {
            console.log("e", e);
            if (e.message.indexOf("403") == -1)
              Modal.showAPIError("delete message");
          }
        )
        .finally(() => {
          StoreUtil.hideLoading();
        });
    },
    clickDeleteDoneOK() {
      console.log("OK");
      location.reload();
    },
    cancel() {
      console.log("cancel");
      this.resetView();
    },
    showSuccessToFront() {
      this.viewState = 3;
      DrawEvent.emit(drawEventType.TO_FRONT);
      setTimeout(() => {
        this.resetView();
      }, this.closeTime);
      StoreUtil.toFrontAPIDisable();
    },
    showSuccessDelete() {
      this.viewState = 4;
      // setTimeout(() => {
      //   this.resetView();
      // }, this.closeTime);
    },
    resetView() {
      this.viewState = 1;
    },
    gotoSiteTop() {
      StoreUtil.gotoTop();
    }
  }
};
</script>

<style scoped lang="sass">
@import "../../sass/common"
@import "../../sass/zindex"
#drawEndUI
    color: white
    position: absolute
    z-index: $z_end
    @include fit
    .drawEndUI__base
        position: relative
        @include fitWH
        .drawEndUI__head
            position: absolute
            top: 15px
            left: 15px
            right: 15px
        .gotoHomeBtn
            position: absolute
        .redrawBtn
            position: absolute
            right: 0

            //right: 15px

        .drawEndUI__foot
            position: absolute
            bottom: 20px
            width: 100%
        .drawEndUI__footBg
            position: absolute
            bottom: 0
            width: 100%
            height: 125px
            background: url("../../assets/ui/toFront-bg.png") 0 0 repeat-x
            background-size: 1px 125px
    .drawEndUI__debug
      position: absolute
      z-index: 10
    .drawEndUI__fx
      @include fit
      text-align: center
      @include bold
      .drawEndUIFx__fx
        position: absolute
        @include fit
        //background-color: rgba(0, 0, 0, 0.5)
        background: url("../../assets/ui/drawendfx.png") center center no-repeat
        background-size: cover
      .drawEndUIFx__head
        position: absolute
        width: 100%
        top: 22px
        @include vw2(40)
      .drawEndUIFx__foot
        position: absolute
        width: 100%
        bottom: 42px
        @include vw2(32)
    .drawEndUI__modal
        text-align: center
        position: absolute
        @include bold
        @include overlayBg
        @include flexCenter
        @include vw(17.5)
        line-height: 1.571428571
        &.drawEndUI__modal--deleted
            flex-direction: column
            flex-wrap: wrap
        .drawEndUI__modalText
            width: 100%
            margin-bottom: 2em
.fx-enter-active, .fx-leave-active
  transition: all .5s
  .drawEndUIFx__fx
    transition: all .5s
    transform: scale(1)
    transform-origin: center center

.fx-enter
  .drawEndUIFx__fx
    transform: scale(1.5)

.fx-enter, .fx-leave-to
  opacity: 0

.operation-enter-active
  transition: all .5s
.operation-leave-active
  transition: all 0s

.operation-enter, .fx-leave-to
  opacity: 0


.toFrontButtons
    text-align: center
    > div
        margin: auto
    .button
        margin-bottom: 18px
        width: 125px
        font-size: 14px
    .text
        @include vw(14)
.deleteModal
  width: 100%
  .buttonPrimary
    margin: 0 auto 2em
  .textButton
    font-weight: normal
.deleteModal__text
  margin-bottom: 1.5em
.deleteModal__text2
  margin-bottom: 2em
</style>
